import type { CardColorType } from "@shared/models/card-stack"
import type { CourseColor } from "@shared/models/colors"

/**
 * Maps from card color names to their rendered color strings.
 * JS copy of the --section-color-* values from colors.css.
 */
export const SECTION_COLOR_MAP: Record<CardColorType, string> = {
  black: "hsl(0, 0%, 13%)",
  red: "hsl(356, 62%, 60%)",
  orange: "hsl(23, 68%, 52%)",
  yellow: "hsl(44, 66%, 49%)",
  green: "hsl(77, 50%, 43%)",
  teal: "hsl(150, 26%, 53%)",
  blue: "hsl(193, 78%, 41%)",
  navy: "hsl(210, 36%, 54%)",
  purple: "hsl(251, 20%, 53%)",
  magenta: "hsl(323, 40%, 46%)",
}

/**
 * Maps from card color names to their light background color strings.
 * JS copy of the --section-color-light-* values from colors.css.
 */
export const SECTION_COLOR_LIGHT_MAP: Record<CardColorType, string> = {
  black: "#dddddd",
  red: "#fdf2f3",
  orange: "#fdeee4",
  yellow: "#fffaeb",
  green: "#eff9d5",
  teal: "#ebf5f1",
  blue: "#e9fbff",
  navy: "#e4edf4",
  purple: "#eeedf4",
  magenta: "#f4e0ec",
}

/**
 * Maps from course color names to their rendered color strings.
 * JS copy of the --course-color-* values from colors.css.
 */
export const COURSE_COLOR_MAP: Record<CourseColor, string> = {
  yellow: "hsl(48, 86%, 64%)",
  green: "hsl(91, 63%, 65%)",
  turquoise: "hsl(156, 68%, 60%)",
  cyan: "hsl(183, 69%, 53%)",
  blue: "hsl(206, 78%, 73%)",
  purple: "hsl(290, 44%, 75%)",
  pink: "hsl(342, 89%, 75%)",
  coral: "hsl(9, 88%, 70%)",
  "muted-yellow": "hsl(50, 55%, 56%)",
  "muted-green": "hsl(90, 39%, 56%)",
  "muted-turquoise": "hsl(150, 38%, 56%)",
  "muted-cyan": "hsl(179, 35%, 50%)",
  "muted-blue": "hsl(205, 31%, 59%)",
  "muted-purple": "hsl(283, 17%, 59%)",
  "muted-pink": "hsl(341, 32%, 56%)",
  "muted-coral": "hsl(5, 36%, 54%)",
}
